import { useEffect } from 'react';
import { ClickLinkDataParamType, updateHref } from '@rmc/webcx-web-libs';

type DefaultContentTrackerPropsType = {
	portalContainer: HTMLElement;
	clickLinkData: ClickLinkDataParamType;
	onRendered?: () => void;
};

export function DefaultContentTracker({
	portalContainer,
	clickLinkData,
	onRendered = () => {},
}: DefaultContentTrackerPropsType) {
	useEffect(() => {
		portalContainer.querySelectorAll('a').forEach((link: HTMLAnchorElement) => {
			link.href = updateHref(clickLinkData, link.href);
		});

		onRendered();
	}, []);

	return null;
}
